import { mapMutations, mapGetters, mapActions } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";
import categoryItem from "./components/category-item/index.vue";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    name: "about",
    mixins: [dynamicHead],
    data() {
        return {};
    },
    components: {
        VueSlideToggle,
        "category-item": categoryItem,
    },
    computed: {
        ...mapGetters({
            seoData: "setting/seoData",
            shortCategoriesList: "about/shortCategoryList",
            shortCategoriesListLoading: "about/shortCategoryListLoading",
            aboutList: "about/aboutList",
            aboutListLoading: "about/aboutListLoading",
        }),
    },
    created() {
        this.getSeoData("about").then(() => {
            this.setPageItem(this.seoData);
        });
        if (!this.shortCategoriesList) {
            this.fetchShortCategoriesList();
        }
        if (!this.aboutList) {
            this.fetchAboutList();
        }
    },
    methods: {
        ...mapActions({
            fetchShortCategoriesList: `about/GET_SHORT_CATEGORY_LIST`,
            fetchAboutList: `about/GET_ABOUT_LIST`,
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
        replaceTags(item) {
            if (this.item !== null) {
                return item.replace(/(<([^>]+)>)/g, "");
            }
        },
    },
    destroyed() {},
};
